import { WorkspaceCategory } from 'v2/types';

import { INSIGHTS_HASH } from './insights/constants';
import { TASKS_HASH } from './tasks/constants';

const workspaceLocationHashes = [
  'dashboard',
  'teammates',
  'teams', // Team Directory
  'documents', // Documents Unsorted
  'private', // Private Documents Unsorted
  'review',
  'question-queue',
  'scribes',
  'pages',
  INSIGHTS_HASH,
  'workflow-ai',
  TASKS_HASH,
  // TODO: Template Literal Types
  ...Object.values(WorkspaceCategory)
] as const;

type WorkspaceLocationHash = (typeof workspaceLocationHashes)[number];

export default WorkspaceLocationHash;

export const DEFAULT_HASH: WorkspaceLocationHash = 'dashboard';

export function isWorkspaceLocationHash(value: string): value is WorkspaceLocationHash {
  const splitValue = value.split('__')[0];
  const folderRoute = ['private', 'documents', 'scribes', 'pages', 'insights', 'tasks'].includes(splitValue);
  const hash = folderRoute ? splitValue : value;

  return workspaceLocationHashes.includes(hash as WorkspaceLocationHash);
}
